import classNames from 'classnames';
import React, { FC, useMemo } from 'react';

import styles from './BaseAvatar.styles.m.css';
import { AvatarTypes, TAvatarBackgroundColorIndex } from './BaseAvatar.types';

interface IAvatarTextContentProps {
  className?: string;
  title?: string | null;
  backgroundColorIndex?: TAvatarBackgroundColorIndex | null;
  type: AvatarTypes;
}

export const BaseAvatarTextContent: FC<IAvatarTextContentProps> = (props) => {
  const { className, title, backgroundColorIndex = '0' } = props;

  // way to extract emoji or letter from string
  const trimmedTitle = useMemo(
    () =>
      Array.from((title || '').trim())
        .slice(0, 1)
        .join(''),
    [title]
  );

  const containerClassName = classNames(
    className,
    styles.textContent,
    styles[`background-${backgroundColorIndex}`]
  );

  return (
    <div
      className={containerClassName}
      data-test="default-avatar"
    >
      {trimmedTitle}
    </div>
  );
};
